import { Skeleton } from '@/components/ui/skeleton'

export function ChatSkeleton() {
  return (
    <div className="flex flex-col h-full">
      {/* Header skeleton */}
      <div className="px-3 py-3 flex items-center gap-2">
        <Skeleton className="h-4 w-6 rounded" />
        <Skeleton className="h-4 w-40 rounded" />
      </div>
      <div className="border-t border-surface-border" />
      {/* Messages skeleton */}
      <div className="flex-1 px-5 py-4 space-y-6">
        <div className="flex justify-center">
          <Skeleton className="h-3 w-32 rounded" />
        </div>
        <div className="flex justify-end">
          <Skeleton className="h-16 w-[65%] rounded-[10px]" />
        </div>
        <div className="flex items-end gap-2">
          <Skeleton className="w-[31px] h-[31px] rounded-full shrink-0" />
          <Skeleton className="h-14 w-[50%] rounded-[10px]" />
        </div>
        <div className="flex justify-end">
          <Skeleton className="h-10 w-[40%] rounded-[10px]" />
        </div>
        <div className="flex items-end gap-2">
          <Skeleton className="w-[31px] h-[31px] rounded-full shrink-0" />
          <Skeleton className="h-20 w-[55%] rounded-[10px]" />
        </div>
      </div>
      {/* Input skeleton */}
      <div className="px-4 pb-4 pt-2 flex items-center gap-3">
        <Skeleton className="flex-1 h-[38px] rounded-full" />
        <Skeleton className="w-[38px] h-[38px] rounded-full shrink-0" />
      </div>
    </div>
  )
}
